
import React from "react";

export function TotalProductFormatter(cellContent,row){

    return(
        <>
            <span className="text-dark font-weight-bolder text-hover-primary mb-1 font-size-lg">
                {row.totalProductQty}
            </span>
        </>
    )
}